module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/crypto-app-4-6809565d454fc16c232ac13c4c2e3166.png";